import { NgModule } from '@angular/core';
import { TrackingEventsBuilder } from './tracking-events.builder';

@NgModule({})
export class TrackingEventModule {
  constructor(_trackingEventsBuilder: TrackingEventsBuilder) {}
}
